module.exports = __webpack_public_path__ + "img/position.2b217b3c.png";